export const STRINGS = {
  bm: {
    nav: { home: "Utama", about: "Tentang Kami", team: "Pasukan Kami", services: "Perkhidmatan Kami", gallery: "Galeri", contact: "Hubungi Kami", admin: "Log Masuk Admin" },
    about: { badge: "Tentang Kami", mission: "Misi Kami", vision: "Visi Kami", founded: "Tahun Diasaskan" },
    services: { badge: "Perkhidmatan Kami", heading: "Apa Yang Kami Lakukan" },
    fleet: { badge: "Armada Kami", heading: "Jenis Lori Yang Tersedia", safety: "Setiap kenderaan melalui pemeriksaan keselamatan berkala — tayar, brek dan enjin." },
    signature: {
      badge: "Armada Berjenama TMG",
      heading: "Armada Kami. Identiti Kami.",
      desc: "Setiap lori Tanjung Marina Global membawa lebih daripada sekadar barangan — ia membawa janji perkhidmatan yang boleh dipercayai di setiap batu jalan raya Malaysia.",
      pills: ["Nationwide Coverage", "Reliable Delivery", "Secure Handling", "On-Time Performance"],
      cta: "Lihat Perkhidmatan Kami",
    },
    values: { badge: "Mengapa Pilih Kami", heading: "Nilai Teras Kami" },
    industries: { badge: "Industri", heading: "Industri Yang Kami Layani" },
    milestones: { badge: "Perjalanan Kami", heading: "Pencapaian Syarikat" },
    team: { badge: "Kepimpinan", heading: "Barisan Kepimpinan Kami" },
    clients: { badge: "Pelanggan Kami", heading: "Dipercayai Oleh Institusi Terkemuka", desc: "Kami berbangga menjadi rakan logistik kepada sekolah, kolej dan agensi kerajaan di seluruh Semenanjung Malaysia." },
    popup: { close: "Tutup", learnMore: "Ketahui Lebih Lanjut" },
    coverage: {
      badge: "Liputan Kami",
      heading: "Liputan Strategik Merentasi Malaysia",
      desc: "Rangkaian operasi kami merangkumi negeri-negeri utama di Semenanjung Malaysia — memastikan penghantaran anda sampai dengan pantas, selamat dan boleh dipercayai.",
    },
    contact: {
      badge: "Hubungi Kami",
      heading: "Sedia Membantu Keperluan Logistik Anda",
      desc: "Hantar pertanyaan atau minta sebut harga — pasukan kami akan menghubungi anda secepat mungkin.",
      formTitle: "Borang Pertanyaan",
      name: "Nama Anda",
      email: "Emel",
      phone: "No. Telefon",
      selectService: "Pilih Perkhidmatan (pilihan)",
      message: "Mesej / butiran penghantaran anda",
      send: "Hantar Pertanyaan",
      sending: "Menghantar...",
      success: "Pertanyaan anda telah dihantar. Kami akan hubungi anda segera!",
      error: "Ralat berlaku",
    },
    footer: { info: "Informasi", nav: "Navigasi", contact: "Hubungi Kami", location: "Lokasi", follow: "Ikuti kami di", loc: "Lokasi", phone: "Telefon", email: "Emel", adminAccess: "Akses Admin", homeLink: "Laman Utama", rights: "Hak cipta terpelihara." },
    cta: {
      heading: "Sedia Untuk Mulakan Penghantaran Anda?",
      desc: "Armada kami bersedia untuk menggerakkan barangan anda dengan selamat dan tepat pada masa — di seluruh Semenanjung Malaysia.",
      button: "Hubungi Kami Sekarang",
    },
    banner: {
      company: "Tanjung Marina Global Sdn. Bhd.",
      aboutSub: "Kenali sejarah, misi dan visi Tanjung Marina Global Sdn. Bhd.",
      teamSub: "Barisan kepimpinan yang menggerakkan Tanjung Marina Global.",
      servicesSub: "Penyelesaian pengangkutan lengkap untuk keperluan rumah, perniagaan dan industri.",
      gallerySub: "Koleksi gambar operasi dan penghantaran Tanjung Marina Global.",
      contactSub: "Hantar pertanyaan atau dapatkan sebut harga daripada pasukan kami.",
    },
    hq: {
      badge: "Ibu Pejabat Kami",
      title: "Ibu Pejabat & Depoh Armada di Melaka",
      desc: "Pusat operasi kami di Tanjung Minyak, Melaka — nadi pergerakan armada TMG ke seluruh Semenanjung Malaysia.",
      stats: [
        ["2022", "Tahun Diasaskan"],
        ["8", "Negeri Liputan"],
        ["5", "Jenis Lori"],
        ["6", "Perkhidmatan Teras"],
      ],
    },
    gallery: { empty: "Tiada gambar buat masa ini. Sila kunjungi semula nanti.", loading: "Memuatkan...", back: "← Kembali ke Kategori", photos: "gambar", emptyCat: "Tiada gambar dalam kategori ini." },
    bio: {
      viewBio: "Lihat Biodata",
      clickHint: "Klik untuk lihat biodata",
      close: "Tutup",
      position: "Jawatan",
      gender: "Jantina",
      age: "Umur",
      status: "Status",
      nationality: "Warganegara",
      race: "Bangsa",
      religion: "Agama",
      education: "Pendidikan",
      institution: "Institusi",
      summary: "Ringkasan",
      years: "tahun",
      noBio: "Biodata terperinci belum ditambah.",
    },
    misc: { loading: "Memuatkan..." },
  },
  en: {
    nav: { home: "Home", about: "About Us", team: "Our People", services: "Our Services", gallery: "Gallery", contact: "Contact Us", admin: "Admin Login" },
    about: { badge: "About Us", mission: "Our Mission", vision: "Our Vision", founded: "Year Founded" },
    services: { badge: "Our Services", heading: "What We Do" },
    fleet: { badge: "Our Fleet", heading: "Available Lorry Types", safety: "Every vehicle undergoes regular safety inspections — tyres, brakes and engine." },
    signature: {
      badge: "TMG Signature Fleet",
      heading: "Our Fleet. Our Identity.",
      desc: "Every Tanjung Marina Global lorry carries more than cargo — it carries a promise of reliable service on every Malaysian road.",
      pills: ["Nationwide Coverage", "Reliable Delivery", "Secure Handling", "On-Time Performance"],
      cta: "See Our Services",
    },
    values: { badge: "Why Choose Us", heading: "Our Core Values" },
    industries: { badge: "Industries", heading: "Industries We Serve" },
    milestones: { badge: "Our Journey", heading: "Company Milestones" },
    team: { badge: "Leadership", heading: "Our Leadership Team" },
    clients: { badge: "Our Clients", heading: "Trusted By Leading Institutions", desc: "We're proud to serve as the logistics partner for schools, colleges and government agencies across Peninsular Malaysia." },
    popup: { close: "Close", learnMore: "Learn More" },
    coverage: {
      badge: "Our Coverage",
      heading: "Strategic Coverage Across Malaysia",
      desc: "Our operations network covers the key states of Peninsular Malaysia — ensuring your deliveries arrive quickly, safely and reliably.",
    },
    contact: {
      badge: "Contact Us",
      heading: "Ready To Support Your Logistics Needs",
      desc: "Send us an enquiry or request a quote — our team will get back to you as soon as possible.",
      formTitle: "Enquiry Form",
      name: "Your Name",
      email: "Email",
      phone: "Phone No.",
      selectService: "Select a Service (optional)",
      message: "Message / delivery details",
      send: "Send Enquiry",
      sending: "Sending...",
      success: "Your enquiry has been sent. We will contact you shortly!",
      error: "Something went wrong",
    },
    footer: { info: "Information", nav: "Navigation", contact: "Contact Us", location: "Location", follow: "Follow us on", loc: "Location", phone: "Phone", email: "Email", adminAccess: "Admin Access", homeLink: "Home", rights: "All rights reserved." },
    cta: {
      heading: "Ready To Start Your Delivery?",
      desc: "Our fleet is ready to move your goods safely and on time — across Peninsular Malaysia.",
      button: "Contact Us Now",
    },
    banner: {
      company: "Tanjung Marina Global Sdn. Bhd.",
      aboutSub: "Discover the history, mission and vision of Tanjung Marina Global Sdn. Bhd.",
      teamSub: "The leadership team driving Tanjung Marina Global forward.",
      servicesSub: "Complete transport solutions for residential, business and industrial needs.",
      gallerySub: "A collection of Tanjung Marina Global's operations and deliveries.",
      contactSub: "Send an enquiry or get a quote from our team.",
    },
    hq: {
      badge: "Our Headquarters",
      title: "Headquarters & Fleet Depot in Melaka",
      desc: "Our operations hub in Tanjung Minyak, Melaka — the heartbeat of TMG's fleet movements across Peninsular Malaysia.",
      stats: [
        ["2022", "Year Founded"],
        ["8", "States Covered"],
        ["5", "Lorry Types"],
        ["6", "Core Services"],
      ],
    },
    gallery: { empty: "No photos yet. Please check back soon.", loading: "Loading...", back: "← Back to Categories", photos: "photos", emptyCat: "No photos in this category yet." },
    bio: {
      viewBio: "View Biodata",
      clickHint: "Click to view biodata",
      close: "Close",
      position: "Position",
      gender: "Gender",
      age: "Age",
      status: "Marital Status",
      nationality: "Nationality",
      race: "Race",
      religion: "Religion",
      education: "Education",
      institution: "Institution",
      summary: "Summary",
      years: "years",
      noBio: "Detailed biodata not added yet.",
    },
    misc: { loading: "Loading..." },
  },
};
